<app-title-bar rootBreadCrumbs="['i18n.core.navigation.reports']" titleText="i18n.domain.reports.false-recordings.title"></app-title-bar>
<div class="row">
  <app-false-recording-form class="col" [form]="filterForm" (searchDTOChanged)="searchReports()"></app-false-recording-form>
</div>
@if(selectedClient && filterForm.controls.startDate.value && filterForm.controls.endDate.value){
  <ejs-grid #grid
            class="grid-with-footer"
            width="100%"
            rowHeight="38"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [dataSource]="data">
    <e-columns>
      <e-column field="date"
                headerText="{{'i18n.domain.reports.false-recordings.grid.date' | translate}}"
                type="date"
                format="dd.MM.yyyy HH:mm:ss"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="parkerRegistrationType"
                headerText="{{'i18n.domain.reports.false-recordings.grid.type' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{formatParkerRegistrationType(data.parkerRegistrationType) | translate}}
        </ng-template>

      </e-column>
      <e-column field="parker.firstName"
                headerText="{{'i18n.domain.reports.false-recordings.grid.name' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data.parker.firstName + ' ' + data.parker.lastName}}
        </ng-template>
      </e-column>
      <e-column field="parker.company.name"
                headerText="{{'i18n.domain.reports.false-recordings.grid.company' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="parker.title"
                headerText="{{'i18n.domain.reports.false-recordings.grid.title' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="agent"
                headerText="{{'i18n.domain.reports.false-recordings.grid.agent' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data.agent ? data.agent.firstname + ' ' + data.agent.lastname : ''}}
        </ng-template>
      </e-column>
      <e-column field="registeredZone.name"
                headerText="{{'i18n.domain.reports.false-recordings.grid.zone' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="knownTag.controlPlateNumber"
                headerText="{{'i18n.domain.reports.false-recordings.grid.controlPlate' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          <span class="text-uppercase">{{data.knownTag.controlPlateNumber | translate}}</span>
        </ng-template>
      </e-column>
      <e-column field="knownTag.identificationCode"
                headerText="{{'i18n.domain.reports.false-recordings.grid.tagId' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>

    </e-columns>
  </ejs-grid>
  <app-reports-footer (saveClicked)="saveReport($event)"></app-reports-footer>
}
